import { Component, inject, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../shared/services/auth.service';
import { LoaderService } from '../../shared/services/loader.service';
import { DownloadFileService } from './services/download-file.service';

@Component({
  selector: 'app-download-file',
  standalone: true,
  imports: [],
  templateUrl: './download-file.component.html',
  styleUrl: './download-file.component.scss'
})
export class DownloadFileComponent {

  private authService = inject(AuthService);
  private toastrService = inject(ToastrService);
  private translocoService = inject(TranslocoService);
  private router = inject(Router);
  private loaderService = inject(LoaderService);
  private downloadFileService = inject(DownloadFileService);
  private route = inject(ActivatedRoute);
  
  ngOnInit(): void {
    this.loaderService.show();
    if (!this.authService.accessToken) {
      sessionStorage.setItem('redirect-url', this.router.url);
      this.router.navigate(['/welcome']);
      return;
    }
    this.downloadFile();
  }

  downloadFile() {


    const fileId = this.route.snapshot.paramMap.get('fileId');
    if (!fileId) {

      this.toastrService.error(this.translocoService.translate('DOWNLOAD_FILE.INVALID_LINK'));

      this.router.navigate(['/dashboard']);
      return;
    }

    this.downloadFileService
      .downloadFile(fileId)
      .subscribe({
        next: (response) => {
          window.open(response, '_blank');
          this.router.navigate(['/dashboard']);
        },
        error: (error) => {
          this.toastrService.error(error.error.detail);
          this.router.navigate(['/dashboard']);
        }
      });
  }

  ngOnDestroy(): void {
    this.loaderService.hide();
  }

}
